module.exports = __webpack_public_path__ + "static/media/shirt.64b18bbe.gif";